import { Heading, Stack, type StackProps, Text } from "@chakra-ui/react";
import * as React from "react";

export interface SectionHeaderProps extends StackProps {
  title: string;
  description: React.ReactNode;
  children?: React.ReactNode;
}

export default function SectionHeader(props: SectionHeaderProps) {
  const { title, description, ...rootProps } = props;
  return (
    <Stack gap={{ base: "6", md: "8" }} w="xs" {...rootProps}>
      <Stack gap="0">
        <Stack gap={{ base: "2", md: "3" }}>
          <Heading as="h2" size="lg">
            {title}
          </Heading>
        </Stack>
        <Text color="fg.muted" fontSize="sm" maxW="3xl">
          {description}
        </Text>
      </Stack>
      {props.children}
    </Stack>
  );
}
